import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "reactstrap";
import { FaYoutube, FaInstagram } from "react-icons/fa";
import axios from "axios";
import AOS from "aos";
import "aos/dist/aos.css";

import ExamplesNavbar from "../../components/Navbars/ExamplesNavbar";
import EntitasPageHeader from "../../components/Headers/EntitasPageHeader";
import DefaultFooter from "../../components/Footers/DefaultFooter";

const EntityPage = () => {
    const [entities, setEntities] = useState([]);
    const [dataInfo, setDataInfo] = useState({});

    useEffect(() => {
        // Initialize AOS
        AOS.init({
            duration: 800,
            easing: "ease-in-out",
            once: true,
        });

        document.body.classList.add("profile-page", "sidebar-collapse");
        document.documentElement.classList.remove("nav-open");
        window.scrollTo(0, 0);

        fetchEntities();
        getDataInfo();

        return () => {
            document.body.classList.remove("profile-page", "sidebar-collapse");
        };
    }, []);

    const fetchEntities = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/entitas/readEntitas`);
            setEntities(response.data);
        } catch (error) {
            console.error("Error fetching entitas data:", error);
        }
    };

    const getDataInfo = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_API_URL}/infoCompany/readInfoCompany`);
            setDataInfo(response.data[0]);
        } catch (error) {
            console.error("Error fetching infoCompany data:", error);
        }
    };

    const overlayStyle = {
        position: "absolute",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0, 0, 0, 0.6)",
        opacity: 0,
        transition: "opacity 0.5s ease",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 1,
    };

    const containerStyle = {
        position: "relative",
        overflow: "hidden",
        cursor: "pointer",
    };

    const imageStyle = {
        width: "100%",
        height: "auto",
        transition: "transform 0.5s ease",
    };

    const socialIconStyle = {
        color: "white",
        fontSize: "24px",
        opacity: 0,
        transition: "opacity 0.5s ease, transform 0.5s ease",
        transform: "scale(0.8)",
        margin: "0 10px",
    };

    const handleMouseEnter = (e) => {
        const overlay = e.currentTarget.querySelector(".overlay");
        const img = e.currentTarget.querySelector("img");
        const icons = e.currentTarget.querySelectorAll(".social-icon");

        overlay.style.opacity = 1;
        img.style.transform = "scale(1.1)";
        icons.forEach((icon) => {
            icon.style.opacity = 1;
            icon.style.transform = "scale(1)";
        });
    };

    const handleMouseLeave = (e) => {
        const overlay = e.currentTarget.querySelector(".overlay");
        const img = e.currentTarget.querySelector("img");
        const icons = e.currentTarget.querySelectorAll(".social-icon");

        overlay.style.opacity = 0;
        img.style.transform = "scale(1)";
        icons.forEach((icon) => {
            icon.style.opacity = 0;
            icon.style.transform = "scale(0.8)";
        });
    };

    const titleStyle = {
        color: "black",
        fontWeight: "bold",
    };

    const descriptionStyle = {
        color: "black",
    };

    return (
        <>
            <ExamplesNavbar />
            <EntitasPageHeader />
            <div className="wrapper">
                <div className="section">
                    <Container>
                        <h2 className="text-center mb-5" data-aos="fade-up"></h2>
                        <Row>
                            {entities.map((entity) => (
                                <Col
                                    md="4"
                                    key={entity.id_entitas}
                                    className="mb-4"
                                    data-aos="fade-up"
                                >
                                    <div
                                        className="entitas-post"
                                        style={containerStyle}
                                        onMouseEnter={handleMouseEnter}
                                        onMouseLeave={handleMouseLeave}
                                    >
                                        <a
                                            href={entity.link}
                                            target="_blank"
                                            rel="noreferrer noopener"
                                        >
                                            <div style={{ position: "relative" }}>
                                                <img
                                                    src={entity.cover}
                                                    alt="Entitas Post"
                                                    style={imageStyle}
                                                />
                                                <div className="overlay" style={overlayStyle}>
                                                    <div>
                                                        {entity.link_ig && (
                                                            <a
                                                                href={entity.link_ig}
                                                                target="_blank"
                                                                rel="noreferrer noopener"
                                                            >
                                                                <FaInstagram
                                                                    className="social-icon"
                                                                    style={socialIconStyle}
                                                                />
                                                            </a>
                                                        )}
                                                        {entity.link_yt && (
                                                            <a
                                                                href={entity.link_yt}
                                                                target="_blank"
                                                                rel="noreferrer noopener"
                                                            >
                                                                <FaYoutube
                                                                    className="social-icon"
                                                                    style={socialIconStyle}
                                                                />
                                                            </a>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </a>
                                    </div>
                                    <div className="entitas-post-success mt-3">
                                        <h5 style={titleStyle}>{entity.judul}</h5>
                                        <p style={descriptionStyle}>{entity.penjelasan}</p>
                                    </div>
                                </Col>
                            ))}
                        </Row>
                    </Container>
                </div>
                <DefaultFooter />
            </div>
        </>
    );
};

export default EntityPage;
